import { render, staticRenderFns } from "./his.vue?vue&type=template&id=6393d841"
import script from "./his.vue?vue&type=script&lang=js"
export * from "./his.vue?vue&type=script&lang=js"
import style0 from "./his.vue?vue&type=style&index=0&id=6393d841&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports